import { render } from "./FranchiseBannerPageComponent.vue?vue&type=template&id=70c51fb3&scoped=true"
import script from "./FranchiseBannerPageComponent.vue?vue&type=script&lang=js"
export * from "./FranchiseBannerPageComponent.vue?vue&type=script&lang=js"

import "./FranchiseBannerPageComponent.vue?vue&type=style&index=0&id=70c51fb3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c51fb3"]])

export default __exports__